// extracted by mini-css-extract-plugin
export default {"header":"Header_header__x45Nl","link":"Header_link__HvoNN"};